export const COMETCHAT_CONSTANTS = {
	APP_ID: '22446316a04df586',
	REGION: 'us',
	AUTH_KEY: '091f525fddae581bf0bdc66b07f1954dd36bd078'
}
